import React from 'react';

const RetirementPlanningBottomline = () => {
  const benefits = [
    {
      title: "Lifestyle Continuity",
      description: "Strategic retirement planning ensures you maintain your desired lifestyle without significant compromises, providing the financial freedom to enjoy your post-career years as envisioned."
    },
    {
      title: "Inflation Protection",
      description: "A properly balanced retirement portfolio combats the erosive effects of inflation, preserving your purchasing power through decades of retirement and maintaining financial security as costs rise."
    },
    {
      title: "Tax Efficiency",
      description: "Comprehensive planning incorporates tax-optimized investment and withdrawal strategies that can significantly increase your usable retirement income while reducing your overall tax burden."
    },
    {
      title: "Legacy Construction",
      description: "Beyond funding your retirement, a strategic approach allows you to build a meaningful legacy for future generations and causes you care about while maintaining control of how your assets are used."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            Bottomline: Benefits of Strategic Retirement Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RetirementPlanningBottomline;